import * as React from "react";
import { DateTime } from "luxon";
import { FormattedMessage } from "react-intl";
import { TaskReady, MissingTask } from "./Messages";
import { StampContext } from "tp/shared/timeclock/messages";
import { StampDirection, ExistingStamp, Task } from "tp/shared/timeclock/models";
import { DeviationListHeader } from "tp/shared/timeclock/components/DeviationListHeader";

interface DisplayMessageProps {
    direction: StampDirection;
    stampInStatus?: string;
    stampOutStatus?: string;
    task: Task;
    lastStamp?: ExistingStamp;
    currentTime: DateTime;
}

const TaskReadyPast = ({ task, currentTime }: { task: Task; currentTime: DateTime }) => {

    const values: {costDiv: string, end: DateTime, isPast: boolean} = {
        costDiv: task.costDivisionName,
        end: task.end,
        isPast: currentTime > task.end
    };
    return <FormattedMessage {...StampContext.TaskReadyPast} values={values} />;
};

export const DeviationMessage = (props: DisplayMessageProps): React.ReactElement => {
    const stampedIn = props.lastStamp && StampDirection[props.lastStamp.direction] === StampDirection.In;
    const stampedOut = props.lastStamp && StampDirection[props.lastStamp.direction] === StampDirection.Out;
    const stampedInToday = stampedIn && props.lastStamp.dateTime.hasSame(props.currentTime, "day");

    if (props.direction == StampDirection.In && props.stampInStatus == "EarlyIn") {
        return (
            <DeviationListHeader>
                <FormattedMessage {...StampContext.EarlyInStamp} /><br />
                <TaskReady task={props.task} currentTime={props.currentTime} /><br />
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    } else if (props.direction == StampDirection.In && props.stampInStatus == "LateIn") {
        return (
            <DeviationListHeader>
                <FormattedMessage {...StampContext.LateInStamp} /><br />
                <TaskReady task={props.task} currentTime={props.currentTime} /><br />
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    } else if (props.direction == StampDirection.Out && props.stampOutStatus == "LateOut") {
        return (
            <DeviationListHeader>
                <FormattedMessage {...StampContext.LateOutStamp} /><br />
                <TaskReadyPast task={props.task} currentTime={props.currentTime} /><br />
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    } else if (props.direction == StampDirection.Out && props.stampOutStatus == "EarlyOut") {
        return (
            <DeviationListHeader>
                <FormattedMessage {...StampContext.EarlyOutStamp} /><br />
                <TaskReadyPast task={props.task} currentTime={props.currentTime} /><br />
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    } else if ((!stampedInToday && !props.task) || (props.task && !props.task.date.hasSame(props.currentTime, "day") && stampedOut)) {
        return (
            <DeviationListHeader>
                <MissingTask stampCostDivisions={null} /><br />
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    } else {
        return (
            <DeviationListHeader>
                <FormattedMessage {...StampContext.ChooseReason} />
            </DeviationListHeader>
        );
    }
};
